// extracted by mini-css-extract-plugin
module.exports = {"root":"TabNav_root__HVAMv","tab":"TabNav_tab__1IArx","link":"TabNav_link__39ybG","selectedLink":"TabNav_selectedLink__3fwpU","disabled":"TabNav_disabled__3Y98t"};